import React from 'react'
import Image from "../../assets/banner-image.jpg"
// import { ArrowRight } from "lucide-react";

const AboutHomeSection = () => {
  return (
    <div className='AboutHomeSection'>
      <div className="mt-24">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Ready to Accelerate Your Digital Journey?
              </h3>
              <p className="text-gray-600 mb-6">
                Our team of experts is ready to help you navigate the complexities of digital transformation and
                deliver solutions that drive real business value.
              </p>
              <ul className="space-y-3 mb-8">
                {['Agile development methodology', 'Expert technology consultants', 'Dedicated support team', 'Industry-specific solutions'].map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mt-1">
                      <div className="w-2 h-2 rounded-full bg-blue-600"></div>
                    </div>
                    <span className="ml-3 text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
              {/* <button className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg flex items-center">
                <span>Schedule a Consultation</span>
                <ArrowRight className="ml-2 w-5 h-5" />
              </button> */}
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src={Image}
                  alt="Technology team collaboration"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-transparent"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutHomeSection